import { CIcon } from '~/icons/types'

export const ciHeading3: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M12 4.5A1.5 1.5 0 0 0 10.5 6v4.5h-5V6a1.5 1.5 0 1 0-3 0v12a1.5 1.5 0 1 0 3 0v-4.5h5V18a1.5 1.5 0 1 0 3 0V6A1.5 1.5 0 0 0 12 4.5ZM22.5 12c0-1.208-.643-2.296-1.719-2.912-1.219-.697-2.73-.652-4.042.12a1.5 1.5 0 1 0 1.522 2.585c.55-.323.929-.159 1.031-.1.095.054.208.151.208.307a.51.51 0 0 1-.146.354.51.51 0 0 1-.354.146 1.5 1.5 0 0 0 0 3 .51.51 0 0 1 .354.146.51.51 0 0 1 .146.354c0 .278-.125.5-.343.608-.316.16-.789.043-1.257-.309a1.502 1.502 0 0 0-1.801 2.401c.863.647 1.82.98 2.745.98.573 0 1.135-.129 1.654-.389 1.235-.616 2.002-1.878 2.002-3.29 0-.728-.226-1.418-.635-2a3.468 3.468 0 0 0 .635-2Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'heading-3',
  type: 'solid'
}
